// extracted by extract-css-chunks-webpack-plugin
module.exports = {"nav-item":"nav-item_K16tF","register-btn":"register-btn_GcE1x"};